import { GamIconName } from '@/views/composables/constants/components/gamIcon.constants';
import type { GamRatingItemType } from '@/views/composables/models/components/GamRatings';

export enum GamRatingPlatform {
  CHESS_COM = 'chessCom',
  LICHESS = 'lichess',
  GAMBITS = 'gambits',
  UNKNOWN = 'unknown',
  OFFLINE = 'offline',
}

const getGambitRating = (): GamRatingItemType => {
  return {
    platform: GamRatingPlatform.GAMBITS,
    icon: GamIconName.GAMBIT,
    isOpen: true,
  };
};

const getAuthRatings = (): GamRatingItemType[] => {
  return [
    {
      platform: GamRatingPlatform.OFFLINE,
      accordion: true,
      isOpen: true,
      isAuth: true,
    },
  ];
};

export const ratingItems = (connect?: (platform: GamRatingPlatform) => void, isAuth?: boolean): GamRatingItemType[] => {
  const ratingItems: GamRatingItemType[] = isAuth ? getAuthRatings() : [getGambitRating()];

  ratingItems.push(
    {
      platform: GamRatingPlatform.LICHESS,
      icon: GamIconName.LICHESS,
      accordion: !!isAuth,
      isOpen: !isAuth,
      connect,
      isAuth,
    },
    {
      platform: GamRatingPlatform.CHESS_COM,
      icon: GamIconName.CHESS_COM,
      accordion: !!isAuth,
      isOpen: !isAuth,
      isAuth,
    },
  );

  return ratingItems;
};
